// extracted by mini-css-extract-plugin
export var grayCircle = "_cl-0";
export var renderAfterShippingOptionWidgetPreviewSelected = "_cl-1";
export var selectedCircle = "_cl-2";
export var shippingOptionImage = "_cl-3";
export var shippingOptionWidgetPreview = "_cl-4";